import { createSlice } from "@reduxjs/toolkit";
import {
  applyOrganizationExtraReducers,
  organizationReducers,
} from "./orgReducers";
import { IAuthState } from "./types";
import { applyUserExtraReducers } from "./userExtraReducers";

const defaultState: IAuthState = {
  username: "",
  organizations: [],
  canAccessAnyAccount: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState: defaultState,
  reducers: {
    ...organizationReducers,
    setServiceUnavailable(state, action) {
      state.isServiceUnavailable = action.payload;
    },
    expireSession(state) {
      state.username = "";
      state.isLoggedIn = false;
    },
    setOrganization(state, action) {
      state.organizationId = action.payload;
    },
    updateOrganization(state, action) {
      if (!action?.payload?.id) return;
      state.organizations.forEach((org) => {
        if (org.id === action.payload.id) {
          Object.assign(org, action.payload);
        }
        return org;
      });
    },
    setAccount(state, action) {
      state.accountId = action.payload;
    },
    setupMFA(state) {
      state.mfa = state.mfa || {};
      state.mfa.mfaEnabled = true;
      state.mfa.mfaSharedSecret = true;
    },
    removeMFA(state) {
      state.mfa = {};
    },
    // Steps back out of a half finished login: drops the MFA challenge and the
    // rejection that came with it, so the credentials form starts clean.
    resetLoginAttempt(state) {
      state.mfa = {};
      state.hasError = false;
      state.errorStatus = undefined;
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    applyUserExtraReducers(builder);
    applyOrganizationExtraReducers(builder);
  },
});

export const actions = authSlice.actions;

export default authSlice.reducer;
